import React from "react";
import AllItemsComponent from "../../components/pos/allItems";

const AllItems = () => {
  return <AllItemsComponent />;
};

export default AllItems;
